<template>
    <div :class="['accordion', {'accordion--active': isActive}]">
        <dt class="accordion__header">
            <button class="toggle-header"
                @click="$parent.makeActive(elementIndex)"
            >
                <span class="toggle-header--left">
                    <img v-if="showIcon && icon"
                        :src="icon"
                        class="toggle-header__icon"
                    >
                    <span v-else-if="showIcon"
                        class="toggle-header__icon"
                    />

                    <h2 class="toggle-header__heading">
                        {{ title }}
                    </h2>
                </span>

                <i class="icon-chevron" />
            </button>
        </dt>

        <transition>
            <dd v-show="isActive"
                class="accordion__content"
            >
                <slot />
            </dd>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'accordion-panel',
    props: {
        elementIndex: {
            type: Number,
            required: true,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
    },
    computed: {
        isActive() {
            return this.elementIndex === this.$parent.activeIndex;
        },
    },
};
</script>


<style lang="scss" scoped>
.accordion {
    &:first-child {
        > dt {
            border-radius: 10px 10px 0 0;
        }
    }

    &:last-child {
        > dd {
            border-radius: 0 0 10px 10px;
        }
    }

    .icon-chevron {
        transform: rotate(180deg);
    }

    &--active {
        .icon-chevron {
            transform: rotate(0deg);
        }
    }

    &__header {
        background: linear-gradient(180deg, $white-color 0%, $whisper-color 100%);

        .toggle-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            text-align: left;
            background-color: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            padding: 2.2rem 1.6rem 1.6rem;

            &--left {
                display: inline-flex;
                align-items: center;
            }

            &__heading {
                font-size: 1.8rem;
                margin: 0;
                font-family: "Nunito";
                color: $daintree-color;
            }

            &__icon {
                width: 23px;
                height: 23px;
                border-radius: 100%;
                margin-right: 2rem;
                background-color: $silver-color;
                border-color: $silver-color;
            }
        }
    }

    &__content {
        background: linear-gradient(180deg, $whisper-color 0%, $athens-gray-color 100%);
        margin-inline-start: 0;
        padding: 1.6rem 1.6rem 2rem;
    }
}
</style>